export default __webpack_public_path__ + "static/media/loading.09ddc917.gif";